import emailjs from "@emailjs/browser";

// Only define team1 cities - team2 will handle everything else
const TEAM1_CITIES = new Set([
  "Pune", 
  "Mumbai", 
  "Mumbai Suburban", 
  "Palghar", 
  "Thane"
]);

// Use the same EmailJS configuration but with different template
const EMAILJS_CONFIG = {
  serviceId: "service_hxqyijx", // Same service ID
  templateId: "template_987naqm", // New template for services
  publicKey: "ttAkRyP_SvbMHcP2L" // Same public key
};

const TEAM_EMAILS = {
  team1: ["namratabaldota@taxsarthi.com"],
  team2: ["sanketsalunkhe@taxsarthi.com"],
  apka: "apka@taxsarthi.com" // Always CC this email
};

export const sendServicesInquiryEmail = async (userData, inquiryData) => {
  try {
    // Validate configuration
    if (!EMAILJS_CONFIG.serviceId || !EMAILJS_CONFIG.templateId || !EMAILJS_CONFIG.publicKey) {
      throw new Error("EmailJS configuration is missing");
    }

    // Determine which team to use based on city
    const userCity = (userData.city || "").trim();
    let team = "team2"; // Default to team2
    
    // Check if city belongs to team1
    if (userCity && TEAM1_CITIES.has(userCity)) {
      team = "team1";
    }

    // Get team recipients
    let teamRecipients = TEAM_EMAILS[team] || [];

    if (!teamRecipients || teamRecipients.length === 0) {
      throw new Error("No valid team recipients configured");
    }

    // Always include apka@taxsarthi.com in addition to team
    const allRecipients = [...teamRecipients, TEAM_EMAILS.apka];

    // Convert recipients array to comma-separated string
    const recipientString = allRecipients.join(",");
    
    // Format selected items based on inquiry type
    let formattedItems = "";
    let serviceType = "";
    
    if (inquiryData.type === "individual") {
      serviceType = "Individual Services";
      formattedItems = inquiryData.selectedItems.map((item, index) => 
        `${index + 1}. ${item}`
      ).join("\n");
    } else if (inquiryData.type === "packages") {
      serviceType = "Service Packages";
      formattedItems = inquiryData.selectedItems.map((packageName, index) => {
        let packageDetails = `${index + 1}. ${packageName}`;
        
        // Add sub-services if available
        if (inquiryData.packageDetails && inquiryData.packageDetails[packageName]) {
          const subServices = inquiryData.packageDetails[packageName];
          packageDetails += "\n   Included Services:";
          subServices.forEach((subService, subIndex) => {
            packageDetails += `\n   - ${subService}`;
          });
        }
        
        return packageDetails;
      }).join("\n\n");
    }

    // Debug logging
    console.log("Services Email Debug Info:", {
      userCity,
      team,
      teamRecipients,
      allRecipients,
      recipientString,
      serviceType,
      inquiryType: inquiryData.type
    });

    const templateParams = {
      user_name: userData.name || "Not provided",
      user_pan: userData.pan || "Not provided",
      user_phone: userData.phone || "Not provided",
      user_email: userData.email || "Not provided",
      user_city: userCity || "Unknown",
      service_type: serviceType,
      selected_items: formattedItems,
      user_message: inquiryData.message || "No additional message provided",
      inquiry_date: new Date().toLocaleDateString("en-IN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      }),
      assigned_team: team,
      email: recipientString, // All recipients (team + apka)
      reply_to: userData.email || "apka@taxsarthi.com"
    };

    console.log("Services Template Params:", templateParams);

    const result = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams,
      EMAILJS_CONFIG.publicKey
    );

    console.log("Services EmailJS Success:", result);

    return { 
      success: result.status === 200,
      team,
      recipients: allRecipients,
      serviceType
    };
  } catch (error) {
    console.error("Services email sending failed:", error);
    
    // Detailed error logging
    if (error.status === 422) {
      console.error("422 Error Details:", {
        message: error.text,
        status: error.status,
        possibleCause: "Template configuration issue or missing email field"
      });
    }
    
    return { 
      success: false, 
      error: error.message || error.text || "Services email sending failed",
      details: {
        city: userData.city,
        time: new Date().toISOString(),
        status: error.status,
        inquiryType: inquiryData.type
      }
    };
  }
};